import { Box } from '@mui/material'
import { IconCell } from 'components/core-ui/IconCell'

export const columns = [
  {
    title: 'Magazin',
    field: 'shopName',
    type: 'string',
    disableSorting: true
  },
  {
    title: 'HUB',
    field: 'hubName',
    type: 'string',
    disableSorting: true
  },
  {
    title: 'Conformitate temperatura marfa',
    field: 'truckSealStatusValue',
    type: 'string',
    disableSorting: true,
    render: row => (
      <Box>{row.conform === true ? 'Da' : row.conform === false ? 'Nu' : 'Nu e cazul'}</Box>
    )
  },
  {
    title: 'Temperatura',
    field: 'arrivalTemperature',
    type: 'string',
    disableSorting: true
  },
  {
    title: 'Aprobator',
    field: 'approvedBy',
    type: 'string',
    disableSorting: true
  },
  {
    title: 'Data aprobare',
    field: 'approvedDate',
    type: 'string',
    disableSorting: true
  },
  {
    title: 'Resigilat',
    field: 'truckSealStatusValue',
    type: 'string'
  }
]
